(() => {
  'use strict';
  // Native details keep Programs usable with JavaScript disabled.
  const menus = [...document.querySelectorAll('.program-menu')];
  document.addEventListener('click', event => {
    menus.forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    menus.forEach(menu => {
      if (menu.open) {
        const ownsFocus = menu.contains(document.activeElement);
        menu.open = false;
        if (ownsFocus) menu.querySelector('summary').focus();
      }
    });
  });
  if (!document.body.classList.contains('page-hyrox')) return;
  const tabs = [...document.querySelectorAll('.hx-station-tab')];
  const panels = [...document.querySelectorAll('.hx-station-panel')];
  const selectStation = (index, focus = false) => {
    tabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected', String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
      panels[i].hidden = i !== index;
    });
    if (focus) tabs[index].focus();
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => selectStation(index));
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next !== undefined) { event.preventDefault(); selectStation(next, true); }
    });
  });
  const goals = {
    new: ['CURIOSITY IS A GREAT START.', 'Tell the team about your current activity and what you want to try. We’ll help you explore an appropriate first session. No race entry needed.', 'Talk about getting started'],
    fitness: ['GIVE YOUR ROUTINE A NEW REASON.', 'Bring the fitness you have and a goal that excites you. Talk to WayMore about combining strength and endurance, learning the stations, and building a routine you can return to.', 'Find my next challenge'],
    race: ['PUT A PLAN BEHIND YOUR FINISH LINE.', 'Tell the team your race date, division, and experience. Discuss the running, station skills, and pacing you want to develop, and the training options available at WayMore.', 'Talk about race preparation']
  };
  document.querySelectorAll('[data-hx-goal]').forEach(button => {
    button.addEventListener('click', () => {
      document.querySelectorAll('[data-hx-goal]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      const [title, copy, cta] = goals[button.dataset.hxGoal];
      document.getElementById('hx-goal-title').textContent = title;
      document.getElementById('hx-goal-copy').textContent = copy;
      const action = document.getElementById('hx-goal-cta');
      action.replaceChildren(document.createTextNode(cta + ' '));
      const arrow = document.createElement('span'); arrow.ariaHidden = 'true'; arrow.textContent = '→'; action.append(arrow);
    });
  });
  const sectionLinks = [...document.querySelectorAll('.hx-subnav-links a')];
  const sections = sectionLinks.map(link => document.querySelector(link.getAttribute('href')));
  let queued = false;
  const updateSection = () => {
    let active = -1;
    sections.forEach((section, index) => { if (section.getBoundingClientRect().top < 215) active = index; });
    sectionLinks.forEach((link, index) => {
      if (index === active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    queued = false;
  };
  document.addEventListener('scroll', () => {
    if (!queued) { queued = true; requestAnimationFrame(updateSection); }
  }, {passive:true});
  updateSection();
})();
